


<template>
    <div class="footer_wrap w-100" ref="footer">
        <!-- Footer Start -->
        <div class="app-footer">
            <b-row align-h="between" class="">
                <b-col cols="" class="position-relative col-auto">
                    <router-link tag="a" to="/web/homepage" class="nav-item-hold">
                        <div :class="{ 'nav-icon': true, 'active': $parent.path == 'homepage', 'inactive': $parent.path != 'homepage' }">
                            <img :src="$parent.path == 'homepage' ? require('./assets/images/flx_footer/home_active.png') : require('./assets/images/flx_footer/home_icon.png')"
                                class="nav-icon" />
                        </div>
                    </router-link>
                </b-col>
                <b-col cols="" class="col-auto">
                    <router-link tag="a" to="/web/wallet" class="nav-item-hold ">
                        <div :class="{ 'nav-icon': true, 'active': $parent.path == 'wallet', 'inactive': $parent.path != 'wallet' }">
                            <img :src="$parent.path == 'wallet' ? require('./assets/images/flx_footer/wallet_active.png') : require('./assets/images/flx_footer/wallet_icon.png')"
                                class="nav-icon" />
                        </div>
                    </router-link>
                </b-col>

                <!-- <b-col cols="" class="col-auto">
                    <router-link tag="a" to="/web/trade" class="nav-item-hold">
                        <div :class="{ 'nav-icon': true, 'active': $parent.path == 'trade', 'inactive': $parent.path != 'trade' }">
                            <img :src="$parent.path == 'trade' ? require('./assets/images/flx_footer/trade_active.png') : require('./assets/images/flx_footer/trade_icon.png')"
                                class="nav-icon" />
                        </div>
                    </router-link>
                </b-col> -->

                <b-col cols="" class="col-auto">
                    <router-link tag="a" to="/web/ib_tree" class="nav-item-hold">
                        <div :class="{ 'nav-icon': true, 'active': $parent.path == 'ib_tree', 'inactive': $parent.path != 'ib_tree' }">
                            <img :src="$parent.path == 'ib_tree' ? require('./assets/images/flx_footer/tree_active.png') : require('./assets/images/flx_footer/tree_icon.png')"
                                class="nav-icon" />
                        </div>
                    </router-link>
                </b-col>

                <b-col cols="" class="col-auto">
                    <router-link tag="a" to="/web/commission" class="nav-item-hold">
                        <div :class="{ 'nav-icon': true, 'active': $parent.path == 'commission', 'inactive': $parent.path != 'commission' }">
                            <img :src="$parent.path == 'commission' ? require('./assets/images/flx_footer/commission_active.png') : require('./assets/images/flx_footer/commission_icon.png')"
                                class="nav-icon" />
                        </div>
                    </router-link>
                </b-col>
            </b-row>
            <!-- <b-col cols="3" v-for="item in footer" :key="item.name" @click="item.name === 'home' ? toHome() : toMall(item)"  class="footer-box">
                <div v-if="item.name === 'notification'" class="position-relative">
                    <img v-if="$route.path.includes(item.path)"
                        :src="require('./assets/images/footer/' + item.name + '_a.png')" alt="" height="28px" width="auto">
                    <img v-else 
                        :src="require('./assets/images/footer/' + item.name + '.png')" alt="" height="28px" width="auto">

                    <span v-if="$root.userInfo.unread > 0" class="unread-badge mt-2 mr-4">
                        {{ $root.userInfo.unread }}
                    </span>
                </div>

                <div v-else>
                    <img v-if="$route.path.includes(item.path)"
                        :src="require('./assets/images/footer/' + item.name + '_a.png')" alt="" height="28px" width="auto">
                    <img v-else 
                        :src="require('./assets/images/footer/' + item.name + '.png')" alt="" height="28px" width="auto">
                </div>

                <p class="" :class="{'active': $route.path.includes(item.path), 'text-primary': $route.path.includes(item.path)}">
                    {{ $t(item.name) }}
                </p>
            </b-col> -->
            <!-- fotter end -->
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            footer: [
                { name: 'home' },
                { name: 'mall', path: '/web/dashboard' },
                { name: 'notification', path: '/web/notification' },
                // { name: 'me', path: '/web/product/orderHistory' },
                { name: 'me', path: '/web/me' },
            ]
        };
    },
    methods: {
        
    },
}
</script>
